import IslanderService from '../../services/Islander/islander.service';

export const getIslanderPartners = async () => {
  let result = [];
  const res = await new IslanderService()
    .getAll({_size: 2147483647, _sort: 'name:asc', status_eq: 1})
    .then(res => res);
  if (res?.data && Array.isArray(res?.data?.items)) {
    const newData = res?.data?.items?.reduce((items, item) => {
      items.push({
        title: item.name || '-',
        value: item.id,
      });
      return items;
    }, []);
    result = newData;
  }
  return result;
};
